export const siteUrl = "https://harmonyofsoul.web.app";
export const socialImage = `${siteUrl}/hos_logo_512x512.png`;
export const defaultSocialImage = socialImage;

export interface TinaSeoFields {
  title?: string | null;
  description?: string | null;
  canonicalPath?: string | null;
  socialImage?: string | null;
  noIndex?: boolean | null;
}

export interface PageMetadata extends TinaSeoFields {
  title: string;
  description: string;
  contentFile: string;
}

export interface ResolvedPageMetadata {
  title: string;
  description: string;
  canonicalUrl: string;
  socialImage: string;
  noIndex: boolean;
}

export const pageMetadata: Record<string, PageMetadata> = {
  "/": {
    contentFile: "home.json",
    title: "Harmony of Soul | KMA Massage, Matrix Drops & Wellbeing",
    description:
      "Discover KMA massage, Matrix Drops and practical wellbeing support with Harmony of Soul. Feel more comfortable, balanced and at home in your body.",
  },
  "/about-us": {
    contentFile: "about-us.json",
    title: "About Harmony of Soul | A Balanced Approach to Wellbeing",
    description:
      "Learn about Harmony of Soul, our whole-person approach to wellbeing, KMA massage, Matrix Drops and complementary support.",
  },
  "/contact": {
    contentFile: "about-us.json",
    title: "Contact Harmony of Soul | Appointments and Location",
    description:
      "Contact Harmony of Soul about appointments, KMA massage and wellbeing support, or find our location and directions.",
    canonicalPath: "/about-us",
  },
  "/events": {
    contentFile: "events.json",
    title: "Wellbeing Events | Meet Harmony of Soul",
    description:
      "Find upcoming wellbeing shows and events where you can meet Harmony of Soul and learn about our services.",
  },
  "/booking": {
    contentFile: "booking.json",
    title: "Book a KMA Massage | Harmony of Soul",
    description: "Choose a time for a KMA Massage or KMA Combo session with Harmony of Soul.",
  },
  "/massage-services": {
    contentFile: "massage-services.json",
    title: "KMA Massage Services | Feel Better and Move Freely",
    description:
      "Explore KMA massage sessions designed to release tension, support comfortable movement and help you feel more at ease.",
  },
  "/matrix-drops": {
    contentFile: "matrix-drops.json",
    title: "Matrix Drops | Information Remedies and Wellbeing",
    description:
      "Explore the Matrix Drops approach, its remedy library and ways to include information remedies in a personal wellbeing practice.",
  },
  "/matrix-drops-protocol": {
    contentFile: "matrix-drops-protocol.json",
    title: "Matrix Drops Protocol | A Whole-Person Wellbeing Journey",
    description: "Explore the Matrix Drops protocol and its practical focus on the body, lifestyle and environment.",
  },
};

export const resolvePageMetadata = (pathname: string, seo?: TinaSeoFields | null): ResolvedPageMetadata | undefined => {
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";
  const defaults = pageMetadata[normalizedPath];
  if (!defaults) return undefined;

  const requestedCanonical = seo?.canonicalPath?.trim();
  const canonicalPath =
    requestedCanonical?.startsWith("/") && !requestedCanonical.startsWith("//")
      ? requestedCanonical
      : defaults.canonicalPath ?? normalizedPath;
  const requestedImage = seo?.socialImage?.trim();

  return {
    title: seo?.title?.trim() || defaults.title,
    description: seo?.description?.trim() || defaults.description,
    canonicalUrl: `${siteUrl}${canonicalPath}`,
    socialImage: requestedImage ? new URL(requestedImage, `${siteUrl}/`).toString() : defaultSocialImage,
    noIndex: seo?.noIndex ?? false,
  };
};
